module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaCargador-di-ap-78d5107a.png";